import React from 'react';

import { TextBlock } from '@/app/_components/TextBlock';
import { TextBlockProps } from './types';

import classes from './index.module.scss';

export const TextBlockGraphQL: React.FC<TextBlockProps> = props => {
  const { id } = props;

  return (
    <div id={`block-${id}`} className={classes.blockWrapper}>
      <TextBlock textBlock={props} />
    </div>
  );
};

export default TextBlockGraphQL;
